<template>
  <div>
    <Header />
    <div class="delivery">
      <div class="flexbox">
        <div class="flexbox-row">
          <div class="flexbox-column flexbox-column__title">
            운송장번호
          </div>
          <div class="flexbox-column flexbox-column__contents">
            {{detail.trpt_company_name}}/{{detail.invc_no}} <!-- CJ대한통운/123456789012 -->
          </div>
        </div>
        <div class="flexbox-row mt15">
          <div class="flexbox-column flexbox-column__title">
            배송발송일시
          </div>
          <div class="flexbox-column flexbox-column__contents">
            <div v-if="!!detail.dlvy_start_pit || !!dateTime">
              {{detail.dlvy_start_pit | dateTime}} <!--2017-04-07 11:11-->
            </div>
          </div>
        </div>
        <div class="flexbox-row mt15">
          <div class="flexbox-column flexbox-column__title">
            상품명
          </div>
          <div class="flexbox-column flexbox-column__contents">
            {{detail.product_name}} <!--신라면100개입-->
          </div>
        </div>
        <div class="flexbox-row mt15">
          <div class="flexbox-column flexbox-column__title">
            수령자
          </div>
          <div class="flexbox-column flexbox-column__contents">
            {{detail.rcpr_name}} <!--홍길동-->
          </div>
        </div>
        <div class="flexbox-row mt15">
          <div class="flexbox-column flexbox-column__title">
            배송지
          </div>
          <div class="flexbox-column flexbox-column__contents">
            {{detail.dlpc_basic_addr}}<br>
            {{detail.dlpc_det_addr}}
            <!-- {{detail.dlpc_post}} -->
            <!-- [000000] 서울시 00구 00동 000-00호
            <br>000APT 000동 000호 -->
          </div>
        </div>
      </div>
      <div class="grey-box">
        배송현황
      </div>
      <div class="list">
        <div class="list-column list-column__item list-column__item--title ml40">
          일시
        </div>
        <div class="list-column list-column__item list-column__item--title">
          배송주문상태
        </div>
      </div>
      <div class="list" v-for="(item, index) in items" :key="index">
        <div class="list-column list-column__number">
          {{index}}
        </div>
        <div class="list-column list-column__item">
          {{item.rgst_pit}}
        </div>
        <div class="list-column list-column__item">
          {{item.dlvy_state_name}}
        </div>
      </div>
      <!-- <div class="list">
        <div class="list-column list-column__number">
          2
        </div>
        <div class="list-column list-column__item list-column__item--blue">
          2017-12-31
        </div>
        <div class="list-column list-column__item list-column__item--blue">
          교환접수
        </div>
      </div>
      <div class="list">
        <div class="list-column list-column__number">
          3
        </div>
        <div class="list-column list-column__item">
          2017-12-30
        </div>
        <div class="list-column list-column__item">
          배송완료
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Header from '@/components/Header';
import axios from 'axios';
import moment from 'moment';

export default {
  name: "Delivery",
  components: {
    Header
  },
  data() {
    return {
      detail: {
        invc_no : '', //(운송장번호)
        dlvy_start_pit : '', //(배송발송일시)
        product_name : '', //(상품명)
        rcpr_name : '', //(수령자)
        dlpc_post : '', //(배송지우편번호)
        dlpc_basic_addr : '', //(배송지기본주소)
        dlpc_det_addr : '' //(배송지상세주소)
      },
      items: []
    }
  },
  filters: { 
    currency: value => { 
      return numeral(value).format("0,0"); 
    },
    date: value => {
      return moment(value.substr(0,8)).format('YYYY-MM-DD');
    },
    dateTime: value => {
      const str = String(value);
      return moment(str.substr(0,8)+' '+str.substr(8,4)).format('YYYY-MM-DD hh:mm');//2019.08.04 14:03
    },
    voucher: value => {
      return value.substring(0,4) + '******' + value.substring(value.length,value.length-2)
    }
  },
  created(){
    let pin = this.$route.params.pin;
    axios.post(process.env.ENDPOINT+'/deliver/request', {
      pin: pin
    })
    .then(response => {
      if(response.status==200){
        let data = response.data;
        if(data.return_cd === '0000'){
          // 등록된 배송정보가 없으면 배송요청 페이지로 이동
          if(data.response.saveYn === 'N'){
            this.$router.push({ name: 'deliver-cert', params: { pin: pin }})
          }
          // 데이터 바인딩
          else{
            this.detail = data.response.data;
            this.items = data.response.list;
          }
        }
        else{
          console.log('rerurn cd error :', data.return_cd);
        }
      }
    })
    .catch(error => {
      console.log(error);
    });
  },
  beforeMount(){

  },
  mounted(){
    
  }
};
</script>

<style scoped lang='scss'>

@import '@/assets/styles/mixin.scss';

.delivery {
  width: 100%;
  margin: 0 auto;
  color: #222;
  font-size: 12px;
  letter-spacing: -0.5px;
  .flexbox {
    padding: 20px;
    box-shadow: 0px 8px 14px -5px #e5e5e5 inset;
    .flexbox-row {
      @include flexbox();
      @include align-items(top);
    }
    .flexbox-column {
      &__title {
        color: #888;
        font-size: 12px;
        width: 72px;
        margin-top: 1px;
      }
      &__contents {
        font-size: 14px;
        width: calc(100% - 72px);
      }
    }
  }
  .grey-box {
    height: 40px;
    padding: 15px 20px;
    background-color: #f5f5f5;
    box-sizing: border-box;
  }
  .list {
    padding: 20px;
    border-bottom: 1px solid #eee;
    @include flexbox();
    @include align-items(center);
    .list-column {
      text-align: center;
      color: #888;
      &__number {
        width: 40px;
      }
      &__item {
        width: calc(50% - 20px);
        &--title {
          color: #222;
          font-weight: 500;
        }
        &--blue {
          color: #13529a;
        }
      }
    }
  }
}
.mt15 {
  margin-top: 15px;
}
.ml40 {
  margin-left: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/Delivery.vue